import React, { Component } from "react";
import "./AddAccount.scss";
import { connect } from "react-redux";
import Select from "react-select";
import AccountList from "../accountList/AccountList.js";
import { gettingStartedProgress } from "../../../../../actions/globalAction";
import {
    validateAccount,
    addAccount,
    createRule,
    setValidAccount,
    changeBulkMode,
    editQuery,
    changeViewQueryMode,
    updateProgressBarInfo,
    setPlatform,
    setAccount,
    setAccountLocation,
    setEntity,
    setPublication,
    setPullComments,
    resetAccountForm,
    setAccountList,
    setAccountListData,
    setBulkFileldValue,
    setFetchNewData,
    setSelectedTopic,
    setSelectedTopicColor,
    setNewTopicName,
    setNewTopicColor,
    setSubTopicName,
    setSubTopicColor,
    setKeywordExpandBlock,
    setAccountExpandBlock,
    setTiktokKeyword,
    setTiktokRuleName,
    setPostListData,
    setPlatformQB,
    getYoutubeChannelId,
} from "../../../../../actions/queryBuilderActions";
import { toast } from "react-toastify";
import { Icon } from "semantic-ui-react";
import Flag from "semantic-ui-react/dist/es/elements/Flag";
import Loader from "semantic-ui-react/dist/es/elements/Loader";
import Dimmer from "semantic-ui-react/dist/es/modules/Dimmer";
import { SketchPicker } from "react-color";
import { Checkbox } from "semantic-ui-react";
import { ReactComponent as GlobeIcon } from "../../../../../assets/svg/globe-icon.svg";
import { ReactComponent as CuraCao } from "../../../../../assets/svg/curacao.svg";
import { ReactComponent as BonaireIcon } from "../../../../../assets/svg/bonaire.svg";
import { ReactComponent as Guernsey } from "../../../../../assets/svg/guernsey.svg";
import { ReactComponent as Isleofman } from "../../../../../assets/svg/Isleofman.svg";
import { ReactComponent as Bostonian } from "../../../../../assets/svg/bostonian.svg";
import { ReactComponent as UnknownFlag } from "../../../../../assets/svg/unknown-flag.svg";
import { ReactComponent as SintMarteen } from "../../../../../assets/svg/sint-maarten.svg";
import { ReactComponent as SouthSudan } from "../../../../../assets/svg/South-Sudan.svg";
import { ReactComponent as Jersey } from "../../../../../assets/svg/jersey.svg";
import { ReactComponent as ColorBox } from "../../../../../assets/svg/color-picker.svg";
import { ReactComponent as SaintBarthelemy } from "../../../../../assets/svg/Saint-Barthelemy.svg";
import { ReactComponent as ExpandViewIcon } from "../../../../../assets/svg/expand-icon.svg";
import { ReactComponent as CollapseViewIcon } from "../../../../../assets/svg/collapse-icon.svg";
import { ReactComponent as ProgressIcon } from "../../../../../assets/svg/progress-completed.svg";
import SelectPlatform from "../selectPlatform/SelectPlatform";
import { fetchFbTokenList, fetchIgTokenList } from "../../../../../actions/tokensAction";
import { LimitMessage } from "../../../../SubscriptionModule/LimitComponents";
import UseGAEventsTracker from "../../../../hooks/UseGAEventsTracker";
class AddAccount extends Component {
    constructor(props) {
        super(props);
        this.GAEventsTracker = UseGAEventsTracker("Listening events");

        this.state = {
            selectedPlatform: [],
            selectedEntity: [],
            selectedLocation: [],
            accountName: "",
            verifiedAccount: false,
            isPublication: false,
            fetchNewData: true,
            organiseExistingData: true,
            accountListData: [],
            selectedTopic: [],
            topicOptions: [],
            subTopicName: "",
            topicName: "",
            booleanValue: "",
            accountList: [],
            displaySelectedTopicColorPicker: false,
            selectedTopicColor: "#000000",
            displayColorPicker: false,
            topicColor: "#000000",
            displaySubtopicColorPicker: false,
            subTopicColor: "#000000",
            bulkInputValue: "",
            masterPlatformList: [],
            fetchComment: false,
            isPlatformOpened: false,
            isSocialAccount: true,
            ytChannelLoading: false,
        };
    }
    componentDidMount() {
        let topicList = this.getTopicsTree(this.props.queryList);
        let newTopicList = [];
        topicList.forEach((ele) => {
            let newObj = Object.assign({}, ele, { label: ele.name, value: ele.id });
            newTopicList.push(newObj);
        });
        this.setState({ topicOptions: newTopicList });
        let allPlatforms = this.props.allPlatforms;
        let newPlatformList = [];
        // if (this.props.islixisnexisSubscribed !== 1) {
        allPlatforms = allPlatforms.filter((ele) => ele.short_name !== "lexisnexis");
        // }
        allPlatforms
            // .filter((ele) => ele.account_configurable == 1)
            .forEach((ele) => {
                let newObj = Object.assign({}, { label: ele.name, value: ele.short_name });
                newPlatformList.push(newObj);
            });
        let sortedPlatformList = newPlatformList.sort((a, b) => {
            if (a.label.toLowerCase() > b.label.toLowerCase()) {
                return 1;
            }
            if (a.label.toLowerCase() < b.label.toLowerCase()) {
                return -1;
            }
            return 0;
        });

        this.setState({ masterPlatformList: sortedPlatformList });
        if (this.props.bulkMode) this.setState({ isSocialAccount: false });
        this.props.fetchFbTokenList();
        this.props.fetchIgTokenList();
        if (this.props.packageObj.package_code == "free") {
            this.props.setFetchNewData(false);
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.isAccountValid !== this.props.isAccountValid && this.props.isAccountValid === true) {
            this.setState({ verifiedAccount: !this.state.verifiedAccount });
        }
        if (prevProps.queryForEdit !== this.props.queryForEdit && Object.keys(this.props.queryForEdit).length > 0) {
            const queryInfo = this.props.queryForEdit;
            const accountInfo = queryInfo.accounts === null ? null : this.getAccountsInfo(queryInfo.accounts) || "";
            // const postInfo = queryInfo.accounts === null ? null : this.getPostInfo(queryInfo.accounts) || "";
            const topicName = queryInfo.topic_name;
            const _subTopicName = queryInfo.subtopic_name;
            const fetchEnabled = queryInfo.data_fetch_enabled;
            const subTopicGraphColor = queryInfo.subtopic_graph_color || "#FF0000";
            let availableTopics = this.state.topicOptions;
            let extractSelectedTopic = availableTopics.filter((ele) => ele.name === topicName);
            this.props.setBulkFileldValue(accountInfo);
            this.props.setSelectedTopic(extractSelectedTopic[0]);
            this.props.setSubTopicName(_subTopicName);
            this.props.setFetchNewData(fetchEnabled === 1 ? true : false);
            let _selectedTopicColor = extractSelectedTopic.length > 0 ? extractSelectedTopic[0].subtopics[0].graph_color : "#000000" || "#000000";
            this.props.setSelectedTopicColor(_selectedTopicColor);
            this.props.setSubTopicColor(subTopicGraphColor);
            // if (postInfo) {
            //     setTimeout(() => {
            //         this.props.setPostListData(postInfo);
            //     }, 0);
            // }
            if (queryInfo.accounts !== null && this.getAccountsInfo(queryInfo.accounts)) {
                setTimeout(() => {
                    this.onAddAccount();
                }, 0);
            }
        }

        if (prevProps.bulkMode !== this.props.bulkMode) {
            if (this.props.bulkMode) this.setState({ isSocialAccount: false });
        }

        if (prevProps.validAccounts !== this.props.validAccounts && this.props.validAccounts.length > 0 && this.props.bulkMode) {
            const updatedAccounts = this.props.bulkInputValue.split("\n").map((ac, index) => {
                let string = ac;
                if (!string.includes("country:") && this.props.validAccounts[index]?.account_exist && this.props.validAccounts[index]?.details[0]?.country_id) {
                    const country_id = this.props.validAccounts[index]?.details[0]?.country_id;
                    const countryShortName = this.props.allLocations.find((val) => val.id === country_id).short_name;
                    if (string[string.length - 1] === ",") string += `country:${countryShortName},`;
                    else string += `,country:${countryShortName},`;

                    if (!string.includes("entity_sub_type:") && this.props.validAccounts[index]?.details[0]?.entity_sub_type) {
                        if (string[string.length - 1] === ",") string += `entity_sub_type:${this.props.validAccounts[index]?.details[0]?.entity_sub_type},`;
                        else string += `,entity_sub_type:${this.props.validAccounts[index]?.details[0]?.entity_sub_type},`;
                    }

                    return string;
                } else return ac;
            });

            this.props.setBulkFileldValue(updatedAccounts.join("\n"));
        }
    }

    getTopicsTree = (alltopics) => {
        let topicsTree = [];
        let topicsObject = {};
        let topics = [];
        alltopics.forEach((e) => {
            if (topics.indexOf(e.topic_id) == -1) {
                topics.push(e.topic_id);
            }
        });
        topics.forEach((topicid) => {
            let subtopics = alltopics.filter((sbt) => sbt.topic_id === topicid);
            topicsObject[topicid] = {
                name: subtopics[0].topic_name,
                color: subtopics[0].graph_color,
                subtopics,
                subtopicsIds: subtopics.map((s) => s.subtopic_id),
            };
            topicsTree.push({
                id: topicid,
                name: subtopics[0].topic_name,
                subtopics,
                color: subtopics[0].graph_color,
            });
        });
        return topicsTree;
    };

    hasDuplicates = (array) => {
        return new Set(array).size !== array.length;
    };
    verifyAccount() {
        if (this.props.verifyingAccount || this.state.ytChannelLoading) return;

        const bulkMode = this.props.bulkMode;
        // if (!bulkMode) {
        //     const platform = this.props.platformName;
        //     const accountName = this.props.accountName;
        //     const location = this.props.location;
        //     const entity = this.props.entityType;
        //     if (platform === null || platform.length === 0 || accountName === "") {
        //         toast.error("Platform & Account can not be empty");
        //         return;
        //     }
        //     const param = {};
        //     let stringObj = platform.value + ":" + accountName + ",";
        //     stringObj += "fetch_comment:" + (this.props.fetchComment ? "1," : "0,");
        //     stringObj += "news_config:" + (this.props.isPublication ? "1," : "0,");
        //     if (location && Object.keys(location).length > 0) {
        //         stringObj += "country:" + location.short_name + ",";
        //     }
        //     if (entity && Object.keys(entity).length > 0) {
        //         stringObj += "entity_sub_type:" + entity.value;
        //     }
        //     param["accounts"] = [stringObj];
        //     this.props.validateAccount(param);
        // }
        if (bulkMode) {
            const bulkFieldValue = this.props.bulkInputValue.trim();
            if (bulkFieldValue == "") {
                toast.error("Please add a account");
                return;
            }
            let accountList = bulkFieldValue.split("\n");
            // Check plan for tiktok
            let isTiktokValidated = true;
            let facebookAuthenticated = true;
            let instagramAuthenticated = true;
            accountList.forEach((val) => {
                if (this.props.company.tiktok_enabled === 0 && val.split(":")[0] === "tiktok") {
                    toast.error("Please upgrade your package to configure TikTok");
                    isTiktokValidated = false;
                    return;
                }
                if (this.props.igTokenList.length === 0 && val.split(":")[0] === "instagram") {
                    toast.error("Please authenticate with your Instagram account first.");
                    instagramAuthenticated = false;
                    return;
                }
                if (
                    this.props.fbTokenList.length === 0 &&
                    (val.split(":")[0] === "facebook" || val.split(":")[0] === "fbcomment" || val.split(":")[0] === "facebook_post")
                ) {
                    toast.error("Please authenticate with your Facebook account first.");
                    facebookAuthenticated = false;
                    return;
                }
            });

            let youtubeAccountsWithoutId = [];

            accountList = accountList.map((ac, i) => {
                if (ac.indexOf("youtube_url:") > -1 && ac.indexOf("youtube:") < 0) {
                    youtubeAccountsWithoutId.push({ ind: i, url: ac.split(",")[0].slice(12) });
                }
                if (ac.split(":")[0] === "tiktok") {
                    return ac.split(",")[0];
                } else return ac;
            });

            if (!isTiktokValidated || !facebookAuthenticated || !instagramAuthenticated) return;

            if (youtubeAccountsWithoutId.length === 0) {
                let params = {};
                params["accounts"] = accountList;
                this.props.validateAccount(params);
            } else {
                this.setState({ ytChannelLoading: true });
                let promises = [];
                youtubeAccountsWithoutId.forEach((y) => {
                    promises.push(
                        this.props
                            .getYoutubeChannelId({ url: y.url })
                            .then((res) => {
                                if (res.action?.payload?.status) {
                                    let url = res.action.payload.channelId.split("/");
                                    return { url: y.url, channelId: url[url.length - 1], ind: y.ind };
                                } else {
                                    return { url: y.url };
                                }
                            })
                            .catch((err) => {
                                return { url: y.url };
                            }),
                    );
                });

                Promise.allSettled(promises).then((res) => {
                    res.forEach((r) => {
                        if (!r?.value?.channelId) return;
                        if (accountList[r?.value?.ind].indexOf("youtube_url") > -1)
                            accountList[r?.value?.ind] = `youtube:${r?.value?.channelId},` + accountList[r?.value?.ind];
                    });

                    let params = {};
                    params["accounts"] = accountList;
                    this.props.setBulkFileldValue(accountList.join("\n"));
                    this.props.validateAccount(params);
                    this.setState({ ytChannelLoading: false });
                });
            }
        }
    }

    customStyle = {
        control: (base) => ({ ...base, border: 0, boxShadow: "none", background: "#F7F7F7", color: "#1F2E3D", fontFamily: "'Roboto', sans-serif" }),
        option: (styles, { isSelected }) => {
            return { ...styles, backgroundColor: isSelected ? "#F7F7F7" : null, color: "#1F2E3D" };
        },
        singleValue: (provided) => {
            return { ...provided, color: "#1F2E3D" };
        },
        dropdownIndicator: (base) => ({
            ...base,
            color: "#697384",
        }),
        clearIndicator: (base) => ({
            ...base,
            color: "#697384",
        }),
        placeholder: (defaultStyles) => {
            return {
                ...defaultStyles,
                color: "#8093b2",
            };
        },
    };
    getAccountsInfo(accounts) {
        let accountData = accounts;
        let accountsVal = "";
        let accountList = JSON.parse(accountData);
        let tiktokKeyword = "";
        JSON.parse(accountData).forEach((ele, ind) => {
            if (ele?.config_type === "tiktok_account") {
                const account = ele;
                let string = `tiktok:${account.query_filter},fetch_comment:0,news_config:0`;
                if (account.location_short_name) {
                    string += `,country:${account.location_short_name}`;
                }
                if (account.entity_sub_type) {
                    string += `,entity_sub_type:${account.entity_sub_type},`;
                }

                accountsVal += string;
            } else if (ele?.config_type === "tiktok") {
                if (ele?.rule_name) this.props.setTiktokRuleName(ele.rule_name.replaceAll('"', ""));
                if (ele?.query_filter) {
                    if (!tiktokKeyword) tiktokKeyword = ele.query_filter;
                    else tiktokKeyword = tiktokKeyword + " OR " + ele.query_filter;
                }
                return;
            } else {
                try {
                    if (JSON.parse(ele)?.keywords) {
                        let post = JSON.parse(ele)?.keywords && JSON.parse(ele)?.keywords[0];
                        const country_name = this.props.allLocations.find((element) => element.id === post.country_id)?.short_name;

                        let string = "facebook_post:" + post.post_url + "," + "country:" + country_name + ",";

                        accountsVal += string;
                    }
                } catch (e) {
                    accountsVal += ele.value.split(",");
                }
            }
            if (accountList.length - 1 !== ind) {
                accountsVal += "\n";
            }
        });

        if (tiktokKeyword) this.props.setTiktokKeyword(tiktokKeyword);

        return accountsVal;
    }

    // getPostInfo(posts) {
    //     let postList = [];
    //     JSON.parse(posts).map((ele) => {
    //         try {
    //             if (JSON.parse(ele)?.keywords) {
    //                 let posts = JSON.parse(ele)?.keywords;
    //                 posts.map((post) => {
    //                     const country_name = this.props.allLocations.find((element) => element.id === post.country_id)?.short_name;
    //                     postList.push({
    //                         post_url: post.post_url,
    //                         platform_name: "facebook_post",
    //                         one_time_fetch: false,
    //                         country_id: post.country_id,
    //                         country_name: country_name,
    //                     });
    //                 });
    //             }
    //         } catch (e) {
    //             return;
    //         }
    //     });
    //     return postList;
    // }

    setAccountName = (accountName) => {
        this.props.setAccount(accountName);
        this.changeAccountStatus();
    };
    handlePlatformChange = (selectedPlatform) => {
        this.props.setPlatform(selectedPlatform);
        this.changeAccountStatus();
    };
    handleLocationChange = (selectedLocation) => {
        this.props.setAccountLocation(selectedLocation);
        this.changeAccountStatus();
    };
    handleEntityTypeChange = (selectedEntity) => {
        this.props.setEntity(selectedEntity);
        this.changeAccountStatus();
    };
    changeAccountStatus() {
        if (this.props.isAccountValid == true) {
            this.props.setValidAccount(false);
        }
    }
    handleCheck = (checktype) => {
        this.setState({ [checktype]: !this.state[checktype] });
        this.props.setCheckIsDirty(true);
    };
    handleTopicChange = (selectedTopic) => {
        if (selectedTopic === null) {
            this.props.setSelectedTopic([]);
            this.props.setSelectedTopicColor("");
        } else {
            this.props.setSelectedTopic(selectedTopic);
            this.props.setSelectedTopicColor(selectedTopic.subtopics[0].graph_color || "");
        }
        this.props.setCheckIsDirty(true);
    };

    onAddAccount = () => {
        const bulkMode = this.props.bulkMode;
        if (!bulkMode) {
            const platform = this.props.platformName;
            const accountName = this.props.accountName;
            const location = this.props.location;
            const entity = this.props.entityType;
            if (platform === null || platform.length === 0) {
                toast.error("Platform can not be empty");
                return;
            }
            if (accountName === "") {
                toast.error("Account can not be empty");
                return;
            }
            const accountObj = {};
            accountObj["account_name"] = accountName;
            accountObj["platform_name"] = platform.value;
            accountObj["fetch_comment"] = this.props.fetchComment ? 1 : 0;
            accountObj["news_config"] = this.props.isPublication ? 1 : 0;
            if (location != null && Object.keys(location).length > 0) {
                accountObj["country"] = location.short_name;
            }
            if (entity !== null && Object.keys(entity).length > 0) {
                accountObj["entity_sub_type"] = entity.value;
            }
            let accList = this.props.accountListData;
            accList.push(accountObj);
            this.props.setAccountListData(accList);

            let stringObj = platform.value + ":" + accountName + ",";
            stringObj += "fetch_comment:" + (this.props.fetchComment ? "1," : "0,");
            stringObj += "news_config:" + (this.props.isPublication ? "1," : "0,");
            if (location != null && Object.keys(location).length > 0) {
                stringObj += "country:" + location.short_name + ",";
            }
            if (entity !== null && Object.keys(entity).length > 0) {
                stringObj += "entity_sub_type:" + entity.value;
            }
            let bulkeditStringObj = "";
            let prevBulkValue = this.props.bulkInputValue;
            if (prevBulkValue !== "") {
                bulkeditStringObj += prevBulkValue;
                bulkeditStringObj += "\n" + stringObj;
            } else {
                bulkeditStringObj = stringObj;
            }
            this.props.setAccountList([stringObj]);
            this.props.setBulkFileldValue(bulkeditStringObj);
            setTimeout(() => {
                this.props.resetAccountForm();
            }, 0);
            this.props.setValidAccount(false);
            this.props.gettingStartedProgress();
        }

        if (bulkMode) {
            let tableList = this.props.accountListData;
            const tableLength = tableList.length;
            const bulkFieldValue = this.props.bulkInputValue.trim();
            if (bulkFieldValue == "") {
                toast.error("Please add a account");
                return;
            }
            let accountList = bulkFieldValue.split("\n");
            const bulkListLength = accountList.filter((ac) => ac.split(":")[0] !== "fbcomment").length;
            if (bulkListLength > 20) {
                toast.error("Maximum 20 accounts are allowed in Bulk Add");
                return;
            }
            let diff = bulkListLength - tableLength;
            if (diff > 0) {
                // accountList.splice(0, tableLength);
            }
            let platformList = this.state.masterPlatformList;
            let modifiedList = accountList.map((ele) => {
                let obj = {};
                let temp = ele.split(",");
                var accountsListObj = {};
                var jsonObject = "{";
                temp.forEach(function (t) {
                    if (!t.trim()) return;
                    let ind = t.indexOf(":");
                    var temp2 = [t.substring(0, ind), t.substring(ind + 1, t.length)];

                    if (jsonObject.length > 1) {
                        jsonObject += ',"' + temp2[0] + '"' + ":" + '"' + temp2[1] + '"';
                    } else {
                        jsonObject += '"' + temp2[0] + '"' + ":" + '"' + temp2[1] + '"';
                        for (let i = 0; i < platformList.length; i++) {
                            if (platformList[i].value.toLowerCase() === temp2[0].toLowerCase()) {
                                accountsListObj.platform_name = platformList[i].value;
                            }
                            if (temp2[0].toLowerCase() === "facebook_post") {
                                accountsListObj.platform_name = "facebook_post";
                            }
                            //     break;
                            // } else if (temp2[0].toLowerCase() === 'fbcomment') {
                            //     accountsListObj.platform = 'Facebook Comments';
                            // }
                        }
                        accountsListObj.account_name = temp2[1];
                        if (temp2[2]) {
                            accountsListObj.account_name += ":" + temp2[2];
                        }
                    }
                });
                jsonObject += "}";
                jsonObject = JSON.parse(jsonObject);
                let combinedObject = { ...accountsListObj, ...jsonObject };
                return combinedObject;
            });

            if (
                modifiedList.some(
                    (ac) =>
                        ac.platform_name === "facebook_post" &&
                        !this.props.allLocations.map((loc) => loc.short_name?.toLowerCase()).includes(ac.country?.toLowerCase()),
                )
            ) {
                toast.error("Please select a valid country for the Facebook post.");
                return;
            }
            this.props.setAccountListData([...modifiedList]);
        }
        this.props.gettingStartedProgress();
    };
    handleTopicNewEntry = (topicName) => {
        this.props.setNewTopicName(topicName);
        this.props.setCheckIsDirty(true);
    };
    handleSubTopicName = (subTopicName) => {
        this.props.setSubTopicName(subTopicName);
        this.props.setCheckIsDirty(true);
    };
    handleSaveQuery = () => {
        //make changes
        // if (this.props.queryList.length >= this.props.packageObj.features.number_of_queries.quota) {
        //     return toast.error(
        //         `You have already used ${this.props.queryList?.length || 0} of ${this.props.packageObj.features.number_of_queries.quota} available Queries.`,
        //     );
        // }
        // this.props.gettingStartedProgress();
        const slectedTopicName = this.props.selectedTopic;
        const newTopicName = this.props.newTopicName;
        const subTopicName = this.props.subTopicName.trim();
        const booleanValue = this.props.booleanValue;
        let selectedLocations = this.props.selectedCountryOptions;
        const accounts = this.props.accountListData;
        const posts = this.props.postListData;
        const availableQueryList = this.props.queryList;
        const queryInfo = this.props.queryForEdit;
        let userId = this.props.user_id;

        if (selectedLocations.length === 0 || selectedLocations === null) {
            toast.error("Please select a Location.");
            return;
        }
        if (booleanValue === "" && accounts.length === 0 && this.props.tiktokKeyword?.length === 0 && this.props.postListData.length === 0) {
            toast.error("Please either create a boolean or add a account.");
            return;
        }

        if (this.props.leftCharacter < 0) {
            toast.error("Please reduce the number of characters of the boolean");
            return;
        }
        if (
            this.props.excludedKeyword.some((arr) => arr.keyword.length > 0) &&
            this.props.genericKeyword.every((arr) => arr.keyword.length === 0) &&
            this.props.keywords.every((arr) => arr.keyword.length === 0)
        ) {
            toast.error("Excluding keywords is not allowed without adding some keywords first.");
            return;
        }
        if (
            this.props.excludedKeyword.some((arr) => arr.keyword.length > 0) &&
            this.props.genericKeyword.every((arr) => arr.keyword.length > 0) &&
            this.props.keywords.every((arr) => arr.keyword.length === 0)
        ) {
            toast.error("Including and excluding keywords is not allowed without adding some keywords first.");
            return;
        }
        if (subTopicName === "") {
            toast.error("Please enter a name of your query.");
            return;
        }
        if (subTopicName.length > 50) {
            toast.error("Please enter query name of maximum 50 characters.");
            return;
        }
        if (slectedTopicName && (Object.keys(slectedTopicName).length === 0 || slectedTopicName === null) && newTopicName === "") {
            toast.error("Please select a topic from a existing topic or enter a new topic name.");
            return;
        }
        if (slectedTopicName && Object.keys(slectedTopicName).length > 0 && newTopicName !== "") {
            toast.error("Please choose only one between existing topic and  new topic field.");
            return;
        }
        if (slectedTopicName && Object.keys(slectedTopicName).length > 0 && this.props.selectedTopicColor.length === 0) {
            toast.error("Please choose a topic colour for the selected topic.");
            return;
        }
        if (subTopicName && subTopicName.length > 0 && this.props.subTopicColor.length === 0) {
            toast.error("Please choose a subtopic colour for the query.");
            return;
        }
        if (newTopicName && newTopicName.length > 0 && this.props.newTopicColor.length === 0) {
            toast.error("Please choose a topic colour for the new topic.");
            return;
        }
        if (newTopicName.length > 0 && newTopicName.length > 50) {
            toast.error("Please enter topic name of maximum 50 characters.");
            return;
        }

        let dublicateQuery = null;
        if (Object.keys(queryInfo).length == 0) {
            dublicateQuery = availableQueryList.find((ele) => {
                return ele.subtopic_name == subTopicName && (ele.topic_name === slectedTopicName?.label || newTopicName === ele.topic_name);
            });
        }
        if (Object.keys(queryInfo).length > 0) {
            let subTopicList = availableQueryList.filter((ele) => ele.subtopic_id !== queryInfo.subtopic_id);
            dublicateQuery = subTopicList.find((ele) => {
                return ele.subtopic_name == subTopicName && (ele.topic_name === slectedTopicName?.label || newTopicName === ele.topic_name);
            });
        }
        if (dublicateQuery) {
            toast.error("Sub Topic already exists");
            return;
        }
        // }
        if (!Array.isArray(selectedLocations)) {
            selectedLocations = [selectedLocations];
        }
        let slectedLocationString = "";
        if (!Array.isArray(selectedLocations)) {
            selectedLocations = [selectedLocations];
        }
        if (selectedLocations.map((ele) => ele.short_name).includes("Worldwide")) {
            slectedLocationString = "";
        } else {
            slectedLocationString = selectedLocations.map((ele) => ele.short_name).join();
        }
        const accountsTobeAdded = accounts.map((ele) => {
            if (ele.platform_name === "tiktok") {
                const params = {};
                params["platform"] = "tiktok";
                params["account_name"] = ele.account_name;
                params["country"] = ele.country;
                params["entity_sub_type"] = ele.entity_sub_type;
                params["account_config_type"] = "own";
                return params;
            } else if (ele.platform_name === "facebook_post") {
                const country_id = this.props.allLocations.find((element) => element.short_name.toLowerCase() === ele.country.toLowerCase())?.id;
                const params = {};
                params["platform"] = "facebook_post";
                params["country_id"] = ele?.country_id || country_id;
                params["facebook_url"] = ele.account_name;
                params["one_time_fetch"] = false;

                return params;
            } else {
                let stringObj = ele.platform_name + ":" + ele.account_name + ",";
                if (ele.platform_name === "youtube" && ele.youtube_url) {
                    stringObj += "youtube_url:" + ele.youtube_url + ",";
                }
                if ("fetch_comment" in ele) {
                    stringObj += "fetch_comment:" + ele.fetch_comment + ",";
                }
                if ("news_config" in ele) {
                    stringObj += "news_config:" + ele.news_config + ",";
                }
                if (ele.country) {
                    stringObj += "country:" + ele.country + ",";
                }
                if (ele.entity_sub_type) {
                    stringObj += "entity_sub_type:" + ele.entity_sub_type + ",";
                }
                if (ele.account_type) {
                    stringObj += "account_type:" + ele.account_type;
                }
                return stringObj;
            }
        });

        if (this.props.tiktokKeyword) {
            this.props.tiktokKeyword.split("OR").map((val) => {
                const params = {};
                params["platform"] = "tiktok";
                params["keywords_or_hashtags"] = val.trim();
                params["rule_name"] = "";
                params["account_config_type"] = "own";
                accountsTobeAdded.push(params);
            });
        }

        const updatedAccounts = [...accountsTobeAdded];

        accountsTobeAdded.map((str) => {
            if (typeof str === "string" && str.split(":")[0] === "fbcomment") {
                updatedAccounts.push("facebook:" + str.split(":").slice(1).join(":"));
            }
        });

        const uniqueUpdatedAccounts = [...new Set(updatedAccounts)];

        const param = {};
        param["accounts"] = 1;
        param["boolean_query"] = booleanValue.replaceAll("\n", "");
        param["company_identifier"] = this.props.company_identifier;
        param["countries"] = slectedLocationString;
        param["data_fetch_enabled"] = this.props.fetchNewData ? 1 : 0;
        param["graph_color"] = slectedTopicName && Object.keys(slectedTopicName).length > 0 ? this.props.selectedTopicColor : this.props.newTopicColor;
        param["name"] = slectedTopicName?.label || newTopicName;
        param["status"] = "Active";
        param["subtopic"] = subTopicName;
        param["subtopic_graph_color"] = this.props.subTopicColor;
        param["twitter_stream_query"] = "";
        param["user_id"] = String(userId);
        param["accountList"] = uniqueUpdatedAccounts;

        const twitterAccounts = this.props.accountListData.filter((account) => account.platform_name === "twitter");
        const accountNames = twitterAccounts.map((account) => `from:${account.account_name} OR retweets_of:${account.account_name}`).join(" OR ");

        param["gnip_query"] = accountNames;
        if (Object.keys(queryInfo).length > 0) {
            param["id"] = queryInfo.research_query_id;
            param["subtopic_id"] = queryInfo.subtopic_id;
            // this.props.editQuery({});
        }
        this.props.createRule(param);
        setTimeout(() => {
            this.props.setTiktokKeyword("");
            this.props.setTiktokRuleName("");
        }, 0);

        this.props.gettingStartedProgress();
        if (Object.keys(queryInfo).length > 0) {
            this.GAEventsTracker("Query updated", subTopicName);
        } else {
            this.GAEventsTracker("Query created", subTopicName);
        }
    };
    // handleBulkMode = (status) => {
    //     const bulkMode = this.props.bulkMode;
    //     if (status == "Active" && bulkMode === false) {
    //         this.props.changeBulkMode(!bulkMode);
    //     }
    //     if (status == "Inactive" && bulkMode === true) {
    //         this.props.changeBulkMode(!bulkMode);
    //     }
    // };
    handleBulkInputChange = (fieldValue) => {
        this.props.setBulkFileldValue(fieldValue);
        this.props.setCheckIsDirty(true);
        if (this.props.isAccountValid == true) {
            this.props.setValidAccount(false);
        }
    };
    changeSelectedTopicColor = (colors) => {
        this.props.setSelectedTopicColor(colors.hex);
        this.props.setCheckIsDirty(true);
    };
    changeSubTopicColor = (colors) => {
        this.props.setSubTopicColor(colors.hex);
        this.props.setCheckIsDirty(true);
    };
    changeTopicColor = (colors) => {
        this.props.setNewTopicColor(colors.hex);
        this.props.setCheckIsDirty(true);
    };
    deleteAccount = (ind) => {
        let tableData = [...this.props.accountListData];
        //Delete one element from the selected index
        tableData.splice(ind, 1);
        let stringObj = "";
        tableData.forEach((ele, ind) => {
            stringObj += ele.platform_name + ":" + ele.account_name + ",";
            if (ele.platform_name === "youtube" && ele.youtube_url) {
                stringObj += "youtube_url:" + ele.youtube_url + ",";
            }
            if ("fetch_comment" in ele) {
                stringObj += "fetch_comment:" + ele.fetch_comment + ",";
            }
            if ("news_config" in ele) {
                stringObj += "news_config:" + ele.news_config + ",";
            }
            if (ele.country) {
                stringObj += "country:" + ele.country + ",";
            }
            if (ele.entity_sub_type) {
                stringObj += "entity_sub_type:" + ele.entity_sub_type + ",";
            }
            if (ele.account_type) {
                stringObj += "account_type:" + ele.account_type + ",";
            }
            if (tableData.length - 1 !== ind) {
                stringObj += "\n";
            }
        });

        this.props.setAccountListData([...tableData]);
        this.props.setBulkFileldValue(stringObj);
    };
    platformList = [
        { label: "Blog", value: "blog" },
        { label: "Facebook", value: "facebook" },
        { label: "Facebook Comments", value: "fbcomment" },
        { label: "Forums", value: "forum" },
        { label: "Instagram", value: "instagram" },
        { label: "Pinterest", value: "pinterest" },
        { label: "News", value: "news" },
        { label: "Reddit", value: "reddit" },
        { label: "Twitter", value: "twitter" },
        { label: "Youtube", value: "youtube" },
    ];

    entityList = [
        { label: "Male", value: "male" },
        { label: "Female", value: "female" },
        { label: "Unknown", value: "unknown" },
        { label: "Person-Unknown", value: "person-unknown" },
        { label: "News", value: "news" },
        { label: "Brand", value: "brand" },
    ];
    customFlagRenderer = (_flagMiss, name) => {
        if (name === "Curacao") {
            return (
                <span>
                    <CuraCao className="custom-icon" />
                </span>
            );
        } else if (name === "Bonaire, Sint Eustatius and Saba") {
            return (
                <span>
                    <BonaireIcon className="custom-icon" />
                </span>
            );
        } else if (name === "Guernsey") {
            return (
                <span>
                    <Guernsey className="custom-icon" />
                </span>
            );
        } else if (name === "Jersey") {
            return (
                <span>
                    <Jersey className="custom-icon" />
                </span>
            );
        } else if (name === "Isle of Man") {
            return (
                <span>
                    <Isleofman className="custom-icon" />
                </span>
            );
        } else if (name === "Millennium Bostonian") {
            return (
                <span>
                    <Bostonian className="custom-icon" />
                </span>
            );
        } else if (name === "Saint Martin") {
            return (
                <span>
                    <SintMarteen className="custom-icon" />
                </span>
            );
        } else if (name === "Sint Maarten") {
            return (
                <span>
                    <SintMarteen className="custom-icon" />
                </span>
            );
        } else if (name === "Saint Barthelemy") {
            return (
                <span>
                    <SaintBarthelemy className="custom-icon" />
                </span>
            );
        } else if (name == "Worldwide") {
            return (
                <span>
                    <GlobeIcon className="custom-icon" />
                </span>
            );
        } else if (name === "South Sudan") {
            return (
                <span>
                    <SouthSudan className="custom-icon" />
                </span>
            );
        } else if (name == "Unknown") {
            return (
                <span>
                    <UnknownFlag className="custom-icon" />
                </span>
            );
        } else {
            return (
                <span>
                    <GlobeIcon className="custom-icon" />
                </span>
            );
        }
    };
    flagRenderer = (item) => <Flag name={item} />;
    formatOptionLabel = ({ value, label, flag, flag_miss }) => (
        <div style={{ display: "flex" }}>
            <div style={{ marginLeft: "0px", color: "#ccc", marginRight: "0px" }}>
                {flag_miss === "yes" ? this.customFlagRenderer(flag_miss, label) : this.flagRenderer(flag)}
            </div>
            <div>{label}</div>
        </div>
    );
    getCountryList = () => {
        let countries = this.props.allLocations || [];
        let countryOptions = countries.filter((ele) => {
            return (
                ele.name !== "Abu Dhabi" &&
                ele.name !== "Antarctica" &&
                ele.name !== "Asia" &&
                ele.name !== "Asia-Pacific" &&
                ele.name !== "Middle East" &&
                ele.name !== "Dubai" &&
                ele.name !== "Sharjah" &&
                ele.name !== "Millennium Bostonian"
            );
        });
        let filteredCountryOptions = countryOptions.map((x) => {
            if (
                x.name == "Curacao" ||
                x.name == "Bonaire, Sint Eustatius and Saba" ||
                x.name == "Guernsey" ||
                x.name == "Isle of Man" ||
                x.name == "Millennium Bostonian" ||
                x.name == "Jersey" ||
                x.name == "Saint Martin" ||
                x.name == "Sint Maarten" ||
                x.name == "Worldwide" ||
                x.name == "South Sudan" ||
                x.name == "Saint Barthelemy" ||
                x.name == "Unknown"
            ) {
                return { value: x.id, label: x.name, flag: x.short_name == null ? "" : x.short_name.toLowerCase(), flag_miss: "yes", short_name: x.short_name };
            } else {
                return { value: x.id, label: x.name, flag: x.short_name == null ? "" : x.short_name.toLowerCase(), flag_miss: "no", short_name: x.short_name };
            }
        });
        return filteredCountryOptions;
    };

    getAccountsString = (accounts) => {
        let string = "";
        let stringArray = [];
        // let posts = this.props.postListData;

        if (accounts.length > 0) {
            stringArray = accounts.map((ele) => {
                let stringObj = "";
                if (ele.platform_name === "youtube" && ele.youtube_url) {
                    stringObj += "youtube_url:" + ele.youtube_url + ",";
                } else stringObj += ele.platform_name + ":" + ele.account_name + ",";
                if ("fetch_comment" in ele) {
                    stringObj += "fetch_comment:" + ele.fetch_comment + ",";
                }
                if ("news_config" in ele) {
                    stringObj += "news_config:" + ele.news_config + ",";
                }
                if (ele.country) {
                    stringObj += "country:" + ele.country + ",";
                }
                if (ele.entity_sub_type) {
                    stringObj += "entity_sub_type:" + ele.entity_sub_type + ",";
                }
                if (ele.account_type) {
                    stringObj += "account_type:" + ele.account_type;
                }
                return stringObj;
            });
        }

        if (this.props.tiktokKeyword) {
            stringArray.push(`tiktokKeyword: ${this.props.tiktokKeyword}`);
        }

        string = stringArray.join("\n");

        return string;
    };

    changeIsPlatformOpened = (data) => {
        this.setState({ isPlatformOpened: data });
    };

    formatAccountInfoBulk = (val) => {
        let stringVal = [];
        val?.split("\n")?.forEach((v) => {
            let s = [];
            if (v.indexOf("youtube_url:") > -1 && v.indexOf("youtube:") > -1) {
                s = v.split(",").slice(1).join(",");
            } else s = v;
            stringVal.push(s);
        });

        stringVal = stringVal?.join("\n");

        return stringVal;
    };

    render() {
        return (
            <div className="addAccount__wrapper">
                <p className="expand__block">
                    <div className="expand__header qb_step7">
                        <span className="open__icon">
                            {!this.props.expandAccountBlock ? (
                                <ExpandViewIcon
                                    onClick={() => {
                                        this.props.setAccountExpandBlock(true);
                                        if (this.props.interactive_help_enabled) this.props.setKeywordExpandBlock(false);
                                    }}
                                />
                            ) : (
                                <CollapseViewIcon onClick={() => this.props.setAccountExpandBlock(false)} />
                            )}
                        </span>
                        <div className="labelAndProgress">
                            <p className="view__label">Configure Accounts and Pages</p>
                            <span className="verified__icon">{this.props.accountListData.length > 0 && <ProgressIcon />}</span>
                        </div>

                        {this.props.expandAccountBlock && this.props.isAdvanced && this.props.queryForEdit && Object.keys(this.props.queryForEdit).length > 0 && (
                            <div className="advancedModeNote">
                                <p>You are editing in advanced mode.</p>
                            </div>
                        )}
                    </div>
                </p>
                {(this.props.expandAccountBlock ||
                    this.props.expandKeywordBlock ||
                    this.props.booleanValue.length > 0 ||
                    this.props.accountListData.length > 0) && <p className="adjust__block"></p>}
                <div className="addAccount">
                    {this.props.expandAccountBlock && (
                        <>
                            <section className="add__account-block">
                                {this.props.bulkMode && !this.state.isSocialAccount ? (
                                    <div style={{ width: "100%" }}>
                                        <div className="socialAccountToggle">
                                            <button
                                                onClick={() => {
                                                    this.setState({ isSocialAccount: true });
                                                    this.props.changeBulkMode(false);
                                                }}
                                                className={this.state.isSocialAccount ? "common__btn qb_step10" : "common__btn__white qb_step10"}>
                                                Social Accounts
                                            </button>
                                            <button
                                                onClick={() => {
                                                    this.setState({ isSocialAccount: false });
                                                    this.props.changeBulkMode(true);
                                                }}
                                                className={!this.state.isSocialAccount ? "common__btn qb_step11" : "common__btn__white qb_step11"}>
                                                Bulk Add
                                            </button>
                                        </div>
                                        <section className="add_account-form">
                                            <p>Note: Maximum 20 accounts are allowed in Bulk Add</p>
                                            <section className="bulk__edit-block">
                                                {this.props.invalidAccounts.length > 0 && (
                                                    <div className="validTicksBlock">
                                                        {this.props.bulkInputValue.split("\n").map((ac, idx) =>
                                                            this.props.invalidAccounts.some((val) => val.includes(ac)) ? (
                                                                <p key={idx}>
                                                                    <Icon name="close" color="red" />
                                                                </p>
                                                            ) : (
                                                                <p key={idx}>
                                                                    <Icon color="green" name="check" />
                                                                </p>
                                                            ),
                                                        )}
                                                    </div>
                                                )}
                                                <textarea
                                                    type="text"
                                                    className="bulk__field"
                                                    value={this.formatAccountInfoBulk(this.props.bulkInputValue)}
                                                    placeholder={`facebook:Radarr,fetch_comment:0,news_config:0,country:IN,entity_sub_type:brand\ninstagram:RadarrTech,fetch_comment:0,news_config:0,country:IN,entity_sub_type:brand\nX:RadarrNews,fetch_comment:0,news_config:0,country:IN,entity_sub_type:brand\nyoutube_url:https://www.youtube.com/c/mkbhd,fetch_comment:1,news_config:0,country:IN,entity_sub_type:male\nfacebook_post:https://www.facebook.com/RadarrTechnologies/videos/528965812246806,fetch_comment:0,news_config:0,country:IN,\nand you can also configure Pinterest, Reddit, TikTok, Blog, News and Forum accounts.`}
                                                    onChange={(ev) => this.handleBulkInputChange(ev.target.value)}></textarea>
                                            </section>
                                            <div className="field__row-normal m-20">
                                                <button className="common__btn offset-hieight" onClick={() => this.verifyAccount()}>
                                                    <span>
                                                        {" "}
                                                        {this.props.verifyingAccount || this.state.ytChannelLoading ? <Loader active size="small" /> : ""}{" "}
                                                        Verify{" "}
                                                    </span>
                                                </button>
                                                <p className="ml-1">Validate to continue account Configuration</p>

                                                <button
                                                    className="common__btn ml-10 offset-hieight"
                                                    disabled={!this.props.isAccountValid}
                                                    onClick={() => this.onAddAccount()}>
                                                    <span> {this.props.addingAccount ? <Loader active size="small" /> : ""} Add </span>
                                                </button>
                                            </div>
                                        </section>
                                        <section className="account__list-table">
                                            <AccountList
                                                isAccountAdded={this.props.isAccountAdded}
                                                accountListData={this.props.accountListData}
                                                deleteAccount={this.deleteAccount}
                                                allLocations={this.props.allLocations}
                                            />
                                        </section>
                                    </div>
                                ) : (
                                    <div style={!this.state.isPlatformOpened ? { flex: "0.6" } : { width: "100%" }}>
                                        <button
                                            onClick={() => {
                                                this.setState({ isSocialAccount: true });
                                                this.props.changeBulkMode(false);
                                                // this.changeAccountStatus();
                                                this.props.setValidAccount(false);
                                            }}
                                            className={this.state.isSocialAccount ? "common__btn qb_step10" : "common__btn__white qb_step10"}>
                                            Social Accounts
                                        </button>
                                        <button
                                            onClick={() => {
                                                this.setState({ isSocialAccount: false });
                                                this.props.changeBulkMode(true);
                                                // this.changeAccountStatus();
                                                this.props.setValidAccount(false);
                                            }}
                                            className={!this.state.isSocialAccount ? "common__btn qb_step11" : "common__btn__white qb_step11"}>
                                            Bulk Add
                                        </button>
                                        <SelectPlatform
                                            changeIsPlatformOpened={this.changeIsPlatformOpened}
                                            accountListData={this.props.accountListData}
                                            postListData={this.props.postListData}
                                            tiktokKeyword={this.props.tiktokKeyword}
                                            tiktokRuleName={this.props.tiktokRuleName}
                                            setCheckIsDirty={this.props.setCheckIsDirty}
                                            isSocialAccount={this.state.isSocialAccount}
                                            isTiktokDisabled={this.props.company.tiktok_enabled === 0}
                                            platform={this.props.platform}
                                            setPlatform={this.props.setPlatformQB}
                                        />
                                    </div>
                                )}

                                {!this.state.isPlatformOpened && !this.props.bulkMode && this.state.isSocialAccount && (
                                    <div className="editable__keyword-block">
                                        <div className="header__align">
                                            <p className="query__header">Your Query - Accounts and Pages</p>
                                        </div>
                                        <textarea
                                            value={this.getAccountsString(this.props.accountListData)}
                                            disabled={true}
                                            className="query__block"
                                            placeholder={`facebook:Radarr,fetch_comment:0,news_config:0,country:IN,entity_sub_type:brand\ninstagram:RadarrTech,fetch_comment:0,news_config:0,country:IN,entity_sub_type:brand\ntwitter:RadarrNews,fetch_comment:0,news_config:0,country:IN,entity_sub_type:brand\nyoutube_url:https://www.youtube.com/c/mkbhd,fetch_comment:1,news_config:0,country:IN,entity_sub_type:male\nfacebook_post:https://www.facebook.com/RadarrTechnologies/videos/528965812246806,fetch_comment:0,news_config:0,country:IN,\nand you can also configure Pinterest, Reddit, TikTok, Blog, News and Forum accounts.`}></textarea>
                                    </div>
                                )}
                            </section>
                        </>
                    )}
                    {this.props.expandAccountBlock && <div className="accountList__separator"></div>}
                    {(this.props.expandAccountBlock ||
                        this.props.expandKeywordBlock ||
                        this.props.booleanValue.length > 0 ||
                        this.props.accountListData.length > 0) && (
                        <div className="save__query-block">
                            <section className="data__fetch-block">
                                {this.props.packageObj.package_code == "free" && (
                                    <div>
                                        <LimitMessage
                                            packageObj={this.props.packageObj}
                                            message={"You cannot change this field, Please upgrade to get more Personalised data."}
                                            limitReached={this.props.packageObj.package_code === "free"}
                                            // totalCount={this.props.packageObj.features.number_of_queries.quota}
                                            // usedCount={queries}
                                        />
                                    </div>
                                )}
                                <div className={`field__row-normal ${this.props.packageObj.package_code == "free" && "disable__cursor"} `}>
                                    <Checkbox
                                        disabled={this.props.packageObj.package_code == "free"}
                                        className="mr-10 pt-0"
                                        checked={this.props.fetchNewData}
                                        onChange={() => this.props.setFetchNewData(!this.props.fetchNewData)}
                                    />
                                    <p>Full data.</p>
                                </div>
                                <div className="field__row-normal m-10">
                                    <Checkbox className="mr-10 pt-0" checked={this.state.organiseExistingData} />
                                    <p> Sample data.</p>
                                </div>
                            </section>

                            <section className="query__arrange-block">
                                <p className="organize__header">
                                    <p className="view__label">Label and organize your query</p>
                                </p>
                                <div>
                                    <div className="field__row m-10">
                                        <div className="field__wrap">
                                            <div className="common__label">
                                                <label>Query Name</label>
                                                <label className="character__length"> (50 Characters Long)</label>{" "}
                                            </div>
                                            <div className="field__with-colorPicker">
                                                <input
                                                    type="text"
                                                    className="add__input crop"
                                                    placeholder="Enter Your Query Name"
                                                    value={this.props.subTopicName}
                                                    onChange={(ev) => {
                                                        this.handleSubTopicName(ev.target.value);
                                                    }}
                                                    maxLength="50"
                                                    title={this.props.subTopicName}
                                                />
                                                {this.props.subTopicColor !== "" && (
                                                    <div
                                                        className="color-swatch"
                                                        onClick={() => this.setState({ displaySubtopicColorPicker: !this.state.displaySubtopicColorPicker })}>
                                                        <div className="swatch-selected-color" style={{ backgroundColor: this.props.subTopicColor }} />
                                                    </div>
                                                )}
                                                {this.state.displaySubtopicColorPicker ? (
                                                    <div className="color-selector">
                                                        <div
                                                            className="color-selector-cover"
                                                            onClick={() => this.setState({ displaySubtopicColorPicker: false })}
                                                        />
                                                        <SketchPicker color={this.props.subTopicColor} onChange={this.changeSubTopicColor} />
                                                    </div>
                                                ) : null}
                                                {this.props.subTopicColor === "" && (
                                                    <span className="color__box">
                                                        <ColorBox
                                                            onClick={() =>
                                                                this.setState({ displaySubtopicColorPicker: !this.state.displaySubtopicColorPicker })
                                                            }
                                                        />
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="field__row m-10 align-start">
                                        <div className="field__wrap">
                                            <label>Save your query in an existing Topic</label>
                                            <div className="field__with-colorPicker">
                                                <div title={this.props.selectedTopic?.label}>
                                                    <Select
                                                        className="platform-list crop"
                                                        value={this.props.selectedTopic}
                                                        isSearchable
                                                        placeholder="Select in Existing Topics"
                                                        options={this.state.topicOptions}
                                                        onChange={this.handleTopicChange}
                                                        maxMenuHeight={140}
                                                        styles={this.customStyle}
                                                        isClearable
                                                        components={{ IndicatorSeparator: () => null }}
                                                    />
                                                </div>
                                                {this.props.selectedTopicColor !== "" && (
                                                    <div
                                                        className="color-swatch"
                                                        onClick={() =>
                                                            this.setState({ displaySelectedTopicColorPicker: !this.state.displaySelectedTopicColorPicker })
                                                        }>
                                                        <div className="swatch-selected-color" style={{ backgroundColor: this.props.selectedTopicColor }} />
                                                    </div>
                                                )}
                                                {this.state.displaySelectedTopicColorPicker ? (
                                                    <div className="color-selector">
                                                        <div
                                                            className="color-selector-cover"
                                                            onClick={() => this.setState({ displaySelectedTopicColorPicker: false })}
                                                        />
                                                        <SketchPicker color={this.props.selectedTopicColor} onChange={this.changeSelectedTopicColor} />
                                                    </div>
                                                ) : null}
                                                {this.props.selectedTopicColor === "" && (
                                                    <span className="color__box">
                                                        <ColorBox
                                                            onClick={() =>
                                                                this.setState({ displaySelectedTopicColorPicker: !this.state.displaySelectedTopicColorPicker })
                                                            }
                                                        />
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                        <label className="align-mid">(Or)</label>
                                        <div className="field__wrap newTopic">
                                            <div className="common__label">
                                                <label>Alternately, create a new Topic for your Query.</label>
                                                <label className="character__length"> (50 Characters Long)</label>{" "}
                                            </div>
                                            <div className="field__with-colorPicker">
                                                <input
                                                    type="text"
                                                    className="add__input crop"
                                                    placeholder="Enter New Topic"
                                                    value={this.props.newTopicName}
                                                    maxLength="50"
                                                    onChange={(ev) => {
                                                        this.handleTopicNewEntry(ev.target.value);
                                                    }}
                                                    title={this.props.newTopicName}
                                                />
                                                {this.props.newTopicColor !== "" && (
                                                    <div
                                                        className="color-swatch"
                                                        onClick={() => this.setState({ displayColorPicker: !this.state.displayColorPicker })}>
                                                        <div className="swatch-selected-color" style={{ backgroundColor: this.props.newTopicColor }} />
                                                    </div>
                                                )}
                                                {this.state.displayColorPicker ? (
                                                    <div className="color-selector">
                                                        <div className="color-selector-cover" onClick={() => this.setState({ displayColorPicker: false })} />
                                                        <SketchPicker color={this.props.newTopicColor} onChange={this.changeTopicColor} />
                                                    </div>
                                                ) : null}
                                                {this.props.newTopicColor === "" && (
                                                    <span className="color__box">
                                                        <ColorBox onClick={() => this.setState({ displayColorPicker: !this.state.displayColorPicker })} />
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    {(this.props.ruleCreatorLoading || this.props.joiningAccount) && (
                                        <div className="list-loading">
                                            <Dimmer inverted active>
                                                <Loader size="big" className="skiptranslate">
                                                    Loading
                                                </Loader>
                                            </Dimmer>
                                        </div>
                                    )}

                                    <footer>
                                        <button
                                            disabled={this.props.ruleCreatorLoading || this.props.joiningAccount}
                                            className={`common__btn query-submit mt-4 ${
                                                (this.props.ruleCreatorLoading || this.props.joiningAccount) && "disabled"
                                            }`}
                                            onClick={() => {
                                                if (this.props.ruleCreatorLoading || this.props.joiningAccount) {
                                                    return;
                                                }
                                                this.handleSaveQuery();
                                                // this.props.gettingStartedProgress();
                                            }}>
                                            {Object.keys(this.props.queryForEdit).length > 0 ? "Update" : "Create"} Query
                                        </button>
                                    </footer>
                                </div>
                            </section>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        isAccountValid: state.queryBuilderReducer.isAccountValid,
        isAccountAdded: state.queryBuilderReducer.isAccountAdded,
        topicList: state.filterSettingReducer.topicsTree,
        company_identifier: state.globalReducer.company.company_identifier,
        user_id: state.globalReducer.company.user_id,
        bulkMode: state.queryBuilderReducer.bulkMode,
        queryForEdit: state.queryBuilderReducer.queryForEdit,
        queryList: state.queryBuilderReducer.createdQueryList.filter((account) => !["competitor", "opa"].includes(account?.config_source?.toLowerCase())),
        compnanyId: state.globalReducer.company.company_id,
        allLocations: state.filterSettingReducer.masterLocations,
        verifyingAccount: state.queryBuilderReducer.verifyingAccount,
        addingAccount: state.queryBuilderReducer.addingAccount,
        ruleCreatorLoading: state.queryBuilderReducer.ruleCreatorLoading,
        joiningAccount: state.queryBuilderReducer.joiningAccount,
        allPlatforms: state.filterSettingReducer.masterPlatforms,
        islixisnexisSubscribed: state.globalReducer.company.lexisnexis_enabled,

        platformName: state.queryBuilderReducer.platformName,
        accountName: state.queryBuilderReducer.accountName,
        location: state.queryBuilderReducer.location,
        entityType: state.queryBuilderReducer.entityType,
        isPublication: state.queryBuilderReducer.isPublication,
        fetchComment: state.queryBuilderReducer.fetchComment,
        accountListData: state.queryBuilderReducer.accountListData,
        accountList: state.queryBuilderReducer.accountList,
        bulkInputValue: state.queryBuilderReducer.bulkInputValue,
        fetchNewData: state.queryBuilderReducer.fetchNewData,
        selectedTopic: state.queryBuilderReducer.selectedTopic,
        newTopicName: state.queryBuilderReducer.newTopicName,
        subTopicName: state.queryBuilderReducer.subTopicName,
        selectedTopicColor: state.queryBuilderReducer.selectedTopicColor,
        newTopicColor: state.queryBuilderReducer.newTopicColor,
        subTopicColor: state.queryBuilderReducer.subTopicColor,
        expandKeywordBlock: state.queryBuilderReducer.expandKeywordBlock,
        expandAccountBlock: state.queryBuilderReducer.expandAccountBlock,
        tiktokRuleName: state.queryBuilderReducer.tiktokRuleName,
        tiktokKeyword: state.queryBuilderReducer.tiktokKeyword,
        keywords: state.queryBuilderReducer.keywords,
        genericKeyword: state.queryBuilderReducer.genericKeyword,
        excludedKeyword: state.queryBuilderReducer.excludedKeyword,
        postListData: state.queryBuilderReducer.postListData,
        invalidAccounts: state.queryBuilderReducer.invalidAccounts,
        validAccounts: state.queryBuilderReducer.validAccounts,
        platform: state.queryBuilderReducer.platform,
        company: state.globalReducer.company,
        fbTokenList: state.tokensReducer.fbTokenList,
        igTokenList: state.tokensReducer.igTokenList,
        interactive_help_enabled: state.globalReducer.interactive_help_enabled,
        packageObj: state.globalReducer.packageObj,
        queryListCheck: state.queryBuilderReducer.createdQueryList,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        validateAccount: (data) => dispatch(validateAccount(data)),
        addAccount: (data) => dispatch(addAccount(data)),
        createRule: (data) => dispatch(createRule(data)),
        setValidAccount: (data) => dispatch(setValidAccount(data)),
        changeBulkMode: (data) => dispatch(changeBulkMode(data)),
        editQuery: (data) => dispatch(editQuery(data)),
        changeViewQueryMode: (data) => dispatch(changeViewQueryMode(data)),
        updateProgressBarInfo: (data) => dispatch(updateProgressBarInfo(data)),
        setPlatform: (data) => dispatch(setPlatform(data)),
        setAccount: (data) => dispatch(setAccount(data)),
        setAccountLocation: (data) => dispatch(setAccountLocation(data)),
        setEntity: (data) => dispatch(setEntity(data)),
        setPublication: () => dispatch(setPublication()),
        setPullComments: () => dispatch(setPullComments()),
        resetAccountForm: () => dispatch(resetAccountForm()),
        setAccountList: (data) => dispatch(setAccountList(data)),
        setAccountListData: (data) => dispatch(setAccountListData(data)),
        setBulkFileldValue: (data) => dispatch(setBulkFileldValue(data)),
        setFetchNewData: (data) => dispatch(setFetchNewData(data)),
        setSelectedTopic: (data) => dispatch(setSelectedTopic(data)),
        setSelectedTopicColor: (data) => dispatch(setSelectedTopicColor(data)),
        setNewTopicName: (data) => dispatch(setNewTopicName(data)),
        setNewTopicColor: (data) => dispatch(setNewTopicColor(data)),
        setSubTopicName: (data) => dispatch(setSubTopicName(data)),
        setSubTopicColor: (data) => dispatch(setSubTopicColor(data)),
        setAccountExpandBlock: (value) => dispatch(setAccountExpandBlock(value)),
        setKeywordExpandBlock: (value) => dispatch(setKeywordExpandBlock(value)),
        gettingStartedProgress: () => dispatch(gettingStartedProgress()),
        setTiktokKeyword: (data) => dispatch(setTiktokKeyword(data)),
        setTiktokRuleName: (data) => dispatch(setTiktokRuleName(data)),
        setPostListData: (data) => dispatch(setPostListData(data)),
        fetchIgTokenList: () => dispatch(fetchIgTokenList()),
        fetchFbTokenList: () => dispatch(fetchFbTokenList()),
        setPlatformQB: (data) => dispatch(setPlatformQB(data)),
        getYoutubeChannelId: (data) => dispatch(getYoutubeChannelId(data)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(AddAccount);
